export default __webpack_public_path__ + "static/media/twitter.c1b907bb.svg";